import React from 'react';
import { LogoFilters } from './components/brand/LogoFilters';
import { SiteNav } from './components/layout/SiteNav';
import { SiteFooter } from './components/layout/SiteFooter';
import { Hero } from './components/sections/Hero';
import { WorkSection } from './components/sections/WorkSection';
import { ProcessSection } from './components/sections/ProcessSection';
import { FounderSection } from './components/sections/FounderSection';
import { ContactSection } from './components/sections/ContactSection';
import { useDocumentMeta } from './hooks/useDocumentMeta';
interface AppProps {
  /** Logo strip label aligned to the headline with no rule (true), or full-width with a rule (false). */
  heroStripAligned?: boolean;
}
export function App({
  heroStripAligned = true
}: AppProps) {
  useDocumentMeta();
  return <div className="grain min-h-screen w-full bg-paper font-sans text-ink" data-id="element-0" data-mp="28t4lee0esat0">
      <LogoFilters data-id="element-1" data-mp="23w4fq47h1a2f" />
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:bg-ink focus:px-5 focus:py-3 focus:text-[15px] focus:text-paper focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-ink" data-id="element-2" data-mp="23ujk0b9f7l2z">
        Skip to content
      </a>
      <SiteNav data-id="element-3" data-mp="3rcsxpt9jqcdw" />
      <main id="main" tabIndex={-1} className="scroll-mt-20 focus:outline-none" data-id="element-4" data-mp="3rd189ei755lx">
        <Hero stripAligned={heroStripAligned} data-id="element-5" data-mp="5gel8p3rovc" />
        <WorkSection data-id="element-6" data-mp="2zld1d7i6tbah" />
        <ProcessSection data-id="element-7" data-mp="2zlv84y2h77wn" />
        <FounderSection data-id="element-8" data-mp="2zmo557bmuj1l" />
        <ContactSection data-id="element-9" data-mp="2zn66ujh2dpgw" />
      </main>
      <SiteFooter data-id="element-10" data-mp="33m5bs42spm8c" />
    </div>;
}